export default __webpack_public_path__ + "static/media/layout-3.bb1ba82a.jpg";